import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { AdminCampaignsPage, AdminConfigCategoriesPage } from "../pages/admin";

export const routes = (
  <>
    <Route
      path="/admin/campaigns"
      element={
        <PrivateRoute>
          <AdminCampaignsPage />
        </PrivateRoute>
      }
    />
    <Route
      path="/admin/config-categories"
      element={
        <PrivateRoute>
          <AdminConfigCategoriesPage />
        </PrivateRoute>
      }
    />
  </>
);
